import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\MathBoardPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function MathBoardPage() {
    const navigate = useNavigate();
    const [problem, setProblem] = useState("");
    const [solution, setSolution] = useState([]);
    function solveProblem() {
        try {
            const parts = problem
                .replace("×", "*")
                .replace("÷", "/")
                .split(/[\+\-\*\/]/);
            const operator = problem.match(/[\+\-\*\/×÷]/)?.[0];
            if (!operator || parts.length !== 2) {
                setSolution(["Please enter a simple math problem like 8 + 7"]);
                return;
            }
            const a = Number(parts[0]);
            const b = Number(parts[1]);
            if (isNaN(a) || isNaN(b)) {
                setSolution(["I couldn't understand those numbers."]);
                return;
            }
            let result = 0;
            let steps = [];
            if (operator === "+") {
                result = a + b;
                steps = [
                    `Step 1: Start with ${a}`,
                    `Step 2: Add ${b}`,
                    `${a} + ${b} = ${result}`,
                ];
            }
            if (operator === "-") {
                result = a - b;
                steps = [
                    `Step 1: Start with ${a}`,
                    `Step 2: Subtract ${b}`,
                    `${a} - ${b} = ${result}`,
                ];
            }
            if (operator === "*" || operator === "×") {
                result = a * b;
                steps = [
                    `Step 1: Multiply ${a} by ${b}`,
                    `${a} × ${b} = ${result}`,
                ];
            }
            if (operator === "/" || operator === "÷") {
                result = a / b;
                steps = [
                    `Step 1: Divide ${a} by ${b}`,
                    `${a} ÷ ${b} = ${result}`,
                ];
            }
            setSolution(steps);
        }
        catch {
            setSolution(["Something went wrong solving the problem."]);
        }
    }
    return (_jsx("div", { style: {
            minHeight: "100vh",
            padding: "40px",
            background: "linear-gradient(180deg,#02060d 0%,#061422 60%,#02060d 100%)",
            color: "#ecfaff",
        }, children: _jsxs("div", { style: { maxWidth: "1000px", margin: "0 auto" }, children: [_jsx("h1", { style: {
                        fontSize: "48px",
                        color: "#17e6ff",
                        marginBottom: "10px",
                    }, children: "Ava Math Board" }), _jsx("p", { style: { marginBottom: "30px", opacity: 0.8 }, children: "Enter a math problem and Ava will solve it step by step." }), _jsx("input", { value: problem, onChange: (e) => setProblem(e.target.value), placeholder: "Example: 48 + 27", style: {
                        width: "100%",
                        padding: "14px",
                        fontSize: "18px",
                        borderRadius: "10px",
                        border: "1px solid rgba(0,255,255,0.3)",
                        background: "rgba(10,20,40,0.8)",
                        color: "#ecfaff",
                    } }), _jsx("button", { onClick: solveProblem, style: {
                        marginTop: "16px",
                        padding: "12px 20px",
                        fontSize: "16px",
                        borderRadius: "10px",
                        background: "#17e6ff",
                        color: "#001018",
                        border: "none",
                        cursor: "pointer",
                    }, children: "Solve" }), _jsx("div", { style: {
                        marginTop: "30px",
                        padding: "30px",
                        borderRadius: "14px",
                        background: "rgba(0,0,0,0.6)",
                        border: "1px solid rgba(0,255,255,0.2)",
                    }, children: solution.map((step, i) => (_jsx("div", { style: {
                            fontSize: "22px",
                            marginBottom: "10px",
                        }, children: step }, i))) }), _jsx("div", { style: { marginTop: "40px" }, children: _jsx("button", { onClick: () => navigate("/education"), children: "Back to Education" }) })] }) }));
}
